import { ClientesPymesService } from './../../services/clientes-pymes.service';
import { AuthService } from './../../services/auth.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-clientes-pymes',
  templateUrl: './clientes-pymes.component.html',
  styleUrls: ['./clientes-pymes.component.css']
})
export class ClientesPymesComponent implements OnInit {

  clientes=[];

  filtro={
    nombre :"",
    email: "",
    telefono:"",
    cif:"",
    activo:true,
    ultimoacceso:""
  }

  paginaActual:number=1;
  paginaSiguiente:number;
  paginaAnterior:number;
  totalPaginas:number;
  ordenacion={};

  constructor(private auth:AuthService, private clientesPymesServices:ClientesPymesService, private router:Router) { }

  ngOnInit() {

    this.ordenacion['campo']="CLnombre";
    this.ordenacion['orden']="ASC";

    this.getClientesPorFiltro();
    
  }

  getClientesPorFiltro(){
    this.clientesPymesServices.getClientes(this.filtro, this.paginaActual, this.ordenacion)
        .subscribe(resp =>{
          this.clientes=resp["clientes_pymes"];
          this.paginaActual=parseInt(resp["pagina"]);
          this.paginaAnterior=parseInt(resp["pag_anterior"]);
          this.paginaSiguiente=parseInt(resp["pag_siguiente"]);
          this.totalPaginas=parseInt(resp["total_paginas"]);
        })
  }

  checkActivo(i:number){
    let returnValue=false;
    if(this.clientes[i].CLactivo=="1"){
      returnValue=true;
    }
    return returnValue;
  }
  checkLaboral(i:number){
    let returnValue=false;
    if(this.clientes[i].CLservicio_laboral=="1"){
      returnValue=true;
    }
    return returnValue;
  }
  checkFiscal(i:number){
    let returnValue=false;
    if(this.clientes[i].CLservicio_fiscal=="1"){
      returnValue=true;
    }
    return returnValue;
  }
  checkContable(i:number){
    let returnValue=false;
    if(this.clientes[i].CLservicio_contable=="1"){
      returnValue=true;
    }
    return returnValue;
  }

  limpiarCampos(){
    this.filtro.nombre="";
    this.filtro.cif="";
    this.filtro.email="";
    this.filtro.activo=true;
    this.filtro.telefono="";
    this.filtro.ultimoacceso="";
  }

  getTodos(){
    this.limpiarCampos();
    this.getClientesPorFiltro();
  }

  actualizarEstado(codigo){
    if(confirm("¿Desea cambiar el estado del cliente seleccionado?")){
        this.clientesPymesServices.actualizarEstado(codigo)
      .subscribe(resp=>{
        alert(resp["mensaje"]);
        this.getClientesPorFiltro();
      })
    }
    
  }

  nextPage(){
    this.clientesPymesServices.getClientes(this.filtro, this.paginaSiguiente, this.ordenacion)
    .subscribe(resp=>{
      this.clientes = resp["clientes_pymes"];
          this.paginaActual=parseInt(resp["pagina"]);
          this.paginaAnterior=parseInt(resp["pag_anterior"]);
          this.paginaSiguiente=parseInt(resp["pag_siguiente"]);
          this.totalPaginas=parseInt(resp["total_paginas"]);
    })
  }

  previousPage(){
    this.clientesPymesServices.getClientes(this.filtro, this.paginaAnterior, this.ordenacion)
    .subscribe(resp=>{
      this.clientes=resp["clientes_pymes"];
          this.paginaActual=parseInt(resp["pagina"]);
          this.paginaAnterior=parseInt(resp["pag_anterior"]);
          this.paginaSiguiente=parseInt(resp["pag_siguiente"]);
          this.totalPaginas=parseInt(resp["total_paginas"]);
    })
  }

  ordenarTabla(campo){
    
    if(this.ordenacion['campo']==campo && this.ordenacion['orden']=='DESC'){
      this.ordenacion['orden']='ASC';
    }else{
      this.ordenacion['campo']=campo;
      this.ordenacion['orden']='DESC';
    }

    

    this.getClientesPorFiltro();
  }

  borrarCliente(cliente){
    let respuesta=prompt('Si desea borrar este cliente, escriba "borrar" en el campo de texto.');


    if(respuesta==="borrar"){
      this.clientesPymesServices.borrarCliente(cliente.CLcodigo)
      .subscribe(resp=>{
        alert(resp["msg"]);
        this.getClientesPorFiltro();
      });
    }else{
      alert("Cliente no borrado.");
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/clientes-pymes/clientes-pymes.component.ts